import styled from 'styled-components'
import Spinner from 'react-spinkit'

export const LoadingOverlayWrapper = styled.div`
    position: fixed;
    background-color: rgba(255,255,255,0.7);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2000;
    text-align: center;
`

export const LoadingItem = styled(Spinner)`
    height: 100px !important;
    width: 100px !important;
    margin: 50% auto !important;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Global/Loader.js